// EXTERNAL DEPENDENCIES
import React, { useState, useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";
import {
  Toolbar,
  AppBar,
  IconButton,
  Menu,
  MenuItem,
  ButtonBase,
} from "@material-ui/core";
import {
  HomeRounded as HomeIcon,
  ExpandMore as MenuArrow,
} from "@material-ui/icons";
import { routes } from "navigation/config";
import { useTranslation } from "react-i18next";
import { useStyles } from "styling/mainStyles";

const Navigation = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const classes = useStyles();
  const location = useLocation();
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);

  const handleMenuOpen = (event) => {
    setMenuAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
  };

  const handleMenuNavigation = (route) => {
    history.push(route);
    handleMenuClose();
  };

  const handleHomeClick = () => history.push(routes.HOME.path);

  const renderMenuItems = useMemo(() => {
    const menuItemsArray = [];
    for (const route in routes) {
      const routeObj = routes[route];
      if (routeObj.showInMenu) {
        menuItemsArray.push(
          <MenuItem
            key={routeObj.name}
            selected={routeObj.path === location.pathname}
            disableGutters
            className={classes.menuItem}
            onClick={() => handleMenuNavigation(routeObj.path)}
          >
            <span>{t(routeObj.name)}</span>
          </MenuItem>
        );
      }
    }
    return menuItemsArray;
    // eslint-disable-next-line
  }, [location, t]);

  return (
    <AppBar position="static" className={classes.menu} elevation={1}>
      <Toolbar>
        <IconButton
          onClick={handleHomeClick}
          edge="start"
          color="inherit"
          aria-label="home"
        >
          <HomeIcon />
        </IconButton>
        <ButtonBase
          aria-controls="simple-menu"
          aria-haspopup="true"
          onClick={handleMenuOpen}
          className={classes.menuButton}
        >
          {t("menu")}
          <MenuArrow />
        </ButtonBase>
        <Menu
          id="simple-menu"
          keepMounted
          getContentAnchorEl={null}
          anchorEl={menuAnchorEl}
          open={Boolean(menuAnchorEl)}
          onClose={handleMenuClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "center" }}
        >
          {renderMenuItems}
        </Menu>
      </Toolbar>
    </AppBar>
  );
};

export default Navigation;
